import { get, set } from 'lodash';
import { Segment } from '@ispm-client/modules/segments/interfaces/index';
import {FormulaService} from "@ispm/shared/services/formula.service";


export class ColorCodingDerivation {


  public getColorCoding(legendCategories: any[], segment: Segment,annotationData) {
    if (segment.annotator) {

        const legendItems = this.legendItemsByAnnotator(legendCategories, segment.annotator);

        if (legendItems) {
          let annotatorLevelCode = get(segment.annotator, 'level.code');
          legendItems.forEach(item => {
            if(get(item,'condition')){
              const interpolationOptions: any = get(item,'interpolationOptions');
              let result;
              if(interpolationOptions) {
                result = FormulaService.evaluateFormula(get(item,'condition'),annotationData,false, interpolationOptions );
              } else {
                result = FormulaService.evaluateFormula(get(item,'condition'),annotationData);
              }
              if(result == true){
                set(segment,'level.fillColor',item.fillColor);
                set(segment, 'level.fillStroke', item.fillStroke);
              }
              return;
            }
            if ((typeof item.type == 'string' && annotatorLevelCode == item.type) || Array.isArray(item.type) &&   item.type.includes(annotatorLevelCode)) {
              set(segment, 'level.fillColor', item.fillColor);
              set(segment, 'level.fillStroke', item.fillStroke);
            }

          });
        }

    }
    }


    legendItemsByAnnotator(legendCategories: any[], annotator) {
      const categories = legendCategories.filter(legends => legends.type == annotator.type);
      const legendItems = categories[0].items;
      return legendItems;
    }


}
